module.exports = __webpack_public_path__ + "img/lageplan_960.7c532950.webp";